import React, { type ChangeEvent } from "react"
import { type Transaction } from "@digits-graphql/frontend/graphql-bearer"
import { Checkbox } from "@digits-shared/DesignSystem/FormElements/Checkbox"
import { type RowSelectionState } from "@tanstack/react-table"
import { BULK_STATUS_UPDATE_LIMIT } from "src/frontend/components/OS/Applications/Shared/Accounting/BulkActions/types"
import { useTransactionsUpdates } from "src/frontend/components/Shared/Transactions/Updates/TransactionsUpdatesContext"

export const CheckboxCell: React.FC<{ transaction: Transaction }> = ({ transaction }) => {
  const { allowBulkUpdate, selectedTransactions, toggleTransaction } = useTransactionsUpdates()

  const toggle = React.useCallback(() => {
    if (!transaction.factId) return
    toggleTransaction(transaction)
  }, [toggleTransaction, transaction])

  if (!allowBulkUpdate || !transaction.factId) return null

  return <Checkbox onChange={toggle} checked={selectedTransactions.has(transaction.factId)} />
}

export const CheckboxHeaderCell: React.FC<{
  rowSelection: RowSelectionState
  toggleRowSelection: (e: ChangeEvent) => void
}> = ({ rowSelection, toggleRowSelection }) => {
  const { allowBulkUpdate } = useTransactionsUpdates()
  const checked = React.useMemo(() => {
    const vals = Object.values(rowSelection)
    return (
      !!vals.length &&
      (vals.filter(Boolean).length >= BULK_STATUS_UPDATE_LIMIT || vals.every(Boolean))
    )
  }, [rowSelection])

  if (!allowBulkUpdate) return null

  return (
    <Checkbox
      containerCSS="transform: translateY(-2px)"
      onChange={toggleRowSelection}
      checked={checked}
    />
  )
}
